// libs
import { createContext, useContext } from 'react';

const EMPTY_OBJECT = {};

//will change interface accordingly
interface DomainConfig {
  THEME: Record<any, any>;
  LOGO: Record<any, any>;
  FAVICON: string;
  PWA_ICONS: Record<number, string>;
  MY_ACCOUNT_DATA: Record<any, any>;
}

const initialValue: DomainConfig = {
  THEME: EMPTY_OBJECT,
  LOGO: EMPTY_OBJECT,
  FAVICON: '',
  PWA_ICONS: EMPTY_OBJECT,
  MY_ACCOUNT_DATA: EMPTY_OBJECT,
};

const DomainConfigContext = createContext(initialValue);

export const useDomainConfig = () => useContext(DomainConfigContext);

export default DomainConfigContext;
